var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39265 9.62049L0.176655 5.42849C0.0630255 5.3044 0 5.14224 0 4.97399C0 4.80573 0.0630255 4.64358 0.176655 4.51949L1.11065 3.61049C1.16476 3.54631 1.23253 3.49504 1.30901 3.46044C1.38548 3.42583 1.46873 3.40876 1.55265 3.41049C1.64002 3.41024 1.72651 3.42785 1.80681 3.46225C1.88712 3.49664 1.95955 3.54709 2.01965 3.61049L4.84765 6.43849L10.9067 0.377487C10.9668 0.314086 11.0392 0.26364 11.1195 0.229247C11.1998 0.194854 11.2863 0.17724 11.3737 0.177487C11.4576 0.175764 11.5408 0.19283 11.6173 0.227435C11.6938 0.26204 11.7615 0.313308 11.8157 0.377487L12.7497 1.28649C12.8085 1.34611 12.8546 1.41714 12.885 1.49521C12.9155 1.57328 12.9296 1.65675 12.9267 1.74049C12.9296 1.82423 12.9155 1.90769 12.885 1.98576C12.8546 2.06384 12.8085 2.13486 12.7497 2.19449L5.29965 9.62049C5.24227 9.68412 5.17216 9.735 5.09387 9.76982C5.01558 9.80465 4.93084 9.82264 4.84515 9.82264C4.75947 9.82264 4.67473 9.80465 4.59644 9.76982C4.51815 9.735 4.44804 9.68412 4.39065 9.62049H4.39265Z",
    fill: "#6A35FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceIcon);
export default __webpack_public_path__ + "static/media/audience_icon.b7cba126446fec9cc22ee8f700676184.svg";
export { ForwardRef as ReactComponent };